import styled from "styled-components";
import {StyledBaseProps} from "@betrue/shared/interfaces";
import {BtAvatar, NoteProps} from "@betrue/ui";
import * as React from "react";
import {Grid, Typography} from "@material-ui/core";
import moment from "moment";

interface NoteViewProps extends StyledBaseProps, NoteProps {
}

export const NoteView = styled((props: NoteViewProps) => (
  <div  key={props.note.id} className={props.className} data-id={props.note.id}>
    <Grid container direction={'row'} spacing={2} >
      <Grid item xs={2} sm={1}>
        <BtAvatar person={props.note.owner}/>
      </Grid>
      <Grid item className={'capital'}  xs={10} sm={11} >
        <b>{props.note.owner.firstName} {props.note.owner.lastName}</b> <Typography
        variant={'caption'} style={{color:'lightgray'}}>{moment(props.note.updatedAt).locale('fr').format("HH:mm")}</Typography>
        <Grid container direction={'row'} spacing={2} alignItems={'center'} alignContent={'center'}>
          <Grid item xs={12}>
            <p style={{whiteSpace: "pre-line",overflowWrap:'break-word'}}> {props.note.content}</p>
          </Grid>
        </Grid>
      </Grid>

    </Grid>

  </div>))`
  & {
    margin-bottom: 30px;
    .capital {
      text-transform: capitalize;
    }

  }
`
